'use client';
import { useTranslations } from 'next-intl';

import { Link } from '../../i18n/navigation';

function NotFoundPage() {
  const t = useTranslations();

  return (
    <div
      className="flex flex-col h-screen justify-center items-center text-white"
      style={{
        backgroundImage: `linear-gradient(rgba(20, 20, 20, 0.958), rgba(20, 20, 20, 0.958)), url(/assets/background.jpg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold text-center">{t('404.title')}</h1>
        <p className="mt-2 text-center text-white">{t('404.description')}</p>

        <Link
          className="mt-4 flex flex-row items-center justify-center h-[40px] rounded-md px-4 bg-red-600 hover:bg-red-500 font-bold text-white"
          href="/"
        >
          {t('404.go_to_home_page_button')}
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
